<template>
  <header id="MainHeader">
    <div class="announcement_container" v-if="announcementData.length > 0">
      <ol class="announcement_list">
        <li
          v-for="(announcement, announcementIndex) in announcementData"
          :key="`announcement_${announcementIndex}`"
          :style="{ transform: `translateX(${announcementIndex * -100}%)` }"
        >
          <a
            v-if="announcement.Link"
            :href="announcement.Link"
            target="_blank"
            >{{ announcement.Text }}</a
          >
          <p v-else>{{ announcement.Text }}</p>
        </li>
      </ol>
    </div>
    <div class="header_container">
      <router-link to="/" class="logo_box">
        <img
          :src="
            $store.getters.imageUrl($store.getters.columnData('header_logo'))
          "
          :alt="$store.getters.columnData('company_name')"
        />
      </router-link>

      <div class="menu_box">
        <ol class="menu_list">
          <li
            v-for="(menu, menuIndex) in menuListData"
            :key="`menu_${menuIndex}`"
          >
            <router-link v-if="menu.Type == 'Link'" :to="menu.Link">
              {{ menu.Title }}
            </router-link>
            <button
              v-if="menu.Type == 'Search'"
              @click="$emit('open-search-dialog')"
            >
              {{ menu.Title }}
            </button>
          </li>
        </ol>

        <ol class="action_list">
          <li>
            <a :href="$store.getters.columnData('menu_contact_link')"
              >線上諮詢</a
            >
          </li>
          <li>
            <button @click="$emit('set-menu-status', !menuStatus)">
              <span class="material-symbols-rounded" v-show="!menuStatus">
                menu
              </span>
              <span class="material-symbols-rounded" v-show="menuStatus">
                close
              </span>
            </button>
          </li>
        </ol>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "MainHeader",
  props: {
    menuStatus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menuListData: [
        {
          Title: "線上車庫",
          Type: "Link",
          Link: "/collections",
        },
        {
          Title: "門市資訊",
          Type: "Link",
          Link: "/shop_info",
        },
        {
          Title: "最新消息",
          Type: "Link",
          Link: "/news",
        },
        {
          Title: "搜尋車款",
          Type: "Search",
          Link: "",
        },
      ],
      announcementTimer: null,
    };
  },
  methods: {
    AnnouncementChange() {
      // 取得所有announcement_list的li
      // 並讀取是否有li的class包含in
      // 如果有則將in的class移除，並加上out
      // 將他的下一個li加上in
      // 如果包含class包含in的li是最後一個li則將第一個li的class加上in
      // 如果沒有則將第一個li的class加上in
      this.announcementTimer != null
        ? clearTimeout(this.announcementTimer)
        : null;

      const announcementList = document.querySelectorAll(
        ".announcement_list li"
      );
      let inIndex = -1;
      announcementList.forEach((item, index) => {
        if (item.classList.contains("in")) {
          inIndex = index;
          item.classList.remove("in");
          item.classList.add("out");
        }
      });
      console.log(announcementList);
      if (inIndex == -1) {
        announcementList[0].classList.add("in");
      } else {
        announcementList[inIndex].classList.remove("in");
        announcementList[inIndex].classList.add("out");
        if (inIndex == announcementList.length - 1) {
          announcementList[0].classList.remove("out");
          announcementList[0].classList.add("in");
        } else {
          announcementList[inIndex + 1].classList.remove("out");
          announcementList[inIndex + 1].classList.add("in");
        }
      }

      this.announcementTimer = setTimeout(() => {
        this.AnnouncementChange();
      }, 5000);
    },
  },
  computed: {
    shopCartData() {
      return this.$store.state.shopCartModule.shopcart;
    },
    shopCartCount() {
      let count = 0;
      this.shopCartData.forEach((item) => {
        count += parseInt(item.amount);
      });
      return count;
    },
    announcementData() {
      let list = [];
      for (let i = 1; i <= 10; i++) {
        const currentText = this.$store.getters.columnData(
          `event_announcement_${i}`
        );
        const currentLink = this.$store.getters.columnData(
          `event_announcement_link_${i}`
        );
        if (currentText != "") {
          list.push({
            Text: currentText,
            Link: currentLink,
          });
        }
      }
      return list;
    },
  },
  watch: {
    announcementData() {
      if (this.announcementData.length > 1 && this.announcementTimer == null) {
        this.$nextTick(() => {
          this.AnnouncementChange();
        });
      }
    },
  },
  mounted() {
    if (this.announcementData.length > 1 && this.announcementTimer == null) {
      this.AnnouncementChange();
    }
  },
};
</script>
